import React, { useEffect, useState } from 'react'
import Layout from '../components/Layout'
import LoginForm from '../components/LoginForm'
import { signInWithEmailAndPassword, onAuthStateChanged } from 'firebase/auth';
import { auth } from '../utils/firebase'
import { navigate } from 'gatsby'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const Admin = () => {
    const [loginEmail, setLoginEmail] = useState('');
    const [loginPassword, setLoginPassword] = useState('')
    const [loginErr, setLoginErr] = useState('')
    const [user, setUser] = useState({});
    onAuthStateChanged(auth, (currentUser) => {
        setUser(currentUser)
    })
    const login = async () => {
        try{
            const user = await signInWithEmailAndPassword(
                auth,
                loginEmail,
                loginPassword
            );
            toast.success('Login Successful!', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                progressStyle: {
                    backgroundColor: '#FFFFFF',
                },
                successIconColor: '#FFFFFF',
                closeButton: false,
                iconColor: '#FFFFFF',
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                });  
            await navigate('/dashboard', {state: {user: user}})
        }catch(err){
            setLoginErr(err.message);
        }
        
    }
    useEffect(() => {
        const script = document.createElement("script");
      
          script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-8941920110730602";
          script.async = true;
      
          document.body.appendChild(script);
      })
    return (
        <Layout>
           <LoginForm setLoginEmail={setLoginEmail} setLoginPassword={setLoginPassword} login={login} loginErr={loginErr} />
           <ToastContainer
        toastStyle={{ backgroundColor: "#4C52EA", color: "#fff" }}
         />
        </Layout>
    )
}

export default Admin
